import { PublicChurch, naverMapSearchUrl } from './churchFinder';

/**
 * 마커를 눌렀을 때 뜨는 인포윈도우 내용을 DOM 으로 만든다.
 *
 * HTML 문자열을 조립하지 않는 이유: 시트 값에 따옴표나 태그가 섞여도 textContent 로
 * 들어가므로 이스케이프가 필요 없다.
 *
 * 닫기 버튼을 직접 다는 이유: NAVER InfoWindow 는 Google Maps 와 달리 기본 닫기 버튼을
 * 제공하지 않는다. 넘겨준 내용만 그대로 그리므로, 버튼이 없으면 한 번 열린 팝업을
 * 사용자가 닫을 방법이 없다.
 */
export function buildInfoContent(church: PublicChurch, onClose: () => void): HTMLElement {
  const wrap = document.createElement('div');
  wrap.style.cssText =
    'position:relative;width:290px;padding:15px;font-family:inherit;color:#222;';

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.setAttribute('aria-label', '닫기');
  closeButton.textContent = '×';
  closeButton.style.cssText =
    'position:absolute;top:6px;right:6px;width:28px;height:28px;padding:0;' +
    'border:0;border-radius:4px;background:transparent;color:#666;' +
    'font-size:20px;line-height:1;cursor:pointer;';
  closeButton.addEventListener('click', onClose);
  wrap.appendChild(closeButton);

  const name = document.createElement('div');
  // 닫기 버튼 자리를 비워 둔다.
  name.style.cssText =
    'margin-bottom:7px;padding-right:28px;font-size:17px;line-height:1.4;font-weight:700;';
  name.textContent = church.name || '';
  wrap.appendChild(name);

  const address = document.createElement('div');
  address.style.cssText = 'margin-bottom:8px;font-size:13px;line-height:1.5;color:#555;';
  address.textContent = church.address || '';
  wrap.appendChild(address);

  const meta = document.createElement('div');
  meta.style.cssText = 'margin-top:5px;font-size:13px;line-height:1.6;';
  const rows: Array<[string, string]> = [];
  if (church.registrationNumber) rows.push(['등록번호', church.registrationNumber]);
  if (church.region) rows.push(['지역', church.region]);
  rows.push(['운영클럽', church.clubs || '-']);
  rows.forEach(([label, value]) => {
    const row = document.createElement('div');
    const strong = document.createElement('b');
    strong.textContent = label;
    row.appendChild(strong);
    row.appendChild(document.createTextNode(` ${value}`));
    meta.appendChild(row);
  });
  wrap.appendChild(meta);

  const link = document.createElement('a');
  link.href = naverMapSearchUrl(church);
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.textContent = '네이버 지도에서 보기';
  link.style.cssText =
    'display:inline-block;margin-top:10px;padding:7px 11px;border-radius:6px;' +
    'text-decoration:none;font-size:13px;font-weight:600;background:#03c75a;color:#fff;';
  wrap.appendChild(link);

  return wrap;
}
